import { Box, Tooltip, Typography } from '@mui/material';

const XNumberField = ({ number, sx = {} }: { number: number; sx?: object }) => {
  if (number === undefined || number === null) return null;

  return (
    <Box display="flex" alignItems="center" sx={sx}>
      <Tooltip title={number}>
        <Typography variant='body2'>{number}</Typography>
      </Tooltip>
    </Box>
  );
};

export default XNumberField;
